import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpaceQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: { id: $tableId }) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
